<template>
	<div class="customer-service-container">
		<!-- 客服头部 -->
		<div class="service-header">
			<h2><span class="service-icon">💬</span> <span data-lang="t_226"></span></h2>
			<p class="service-subtitle" data-lang="t_227"></p>
		</div>

		<!-- 联系方式卡片 -->
		<div class="contact-cards">
			<div class="contact-card" @click="handleContact('email')">
				<div class="card-icon">📧</div>
				<h3 data-lang="t_228"></h3>
				<p>agegfgm@gmail.com</p>
				<div class="card-arrow">→</div>
			</div>

			<div class="contact-card" @click="handleContact('telegram')">
				<div class="card-icon">✈️</div>
				<h3>Telegram</h3>
				<p>https://t.me/alphasocialcha</p>
				<div class="card-arrow">→</div>
			</div>

			<div class="contact-card" @click="handleContact('twitter')">
				<div class="card-icon">🐦</div>
				<h3>Twitter</h3>
				<p>https://x.com/alphasocialcha</p>
				<div class="card-arrow">→</div>
			</div>
		</div>

		<!-- 常见问题 -->
		<div class="faq-section">
			<h3 data-lang="t_229"></h3>
			<div class="faq-list">
				<div v-for="(faq, index) in faqs" :key="index" class="faq-item" @click="toggleFaq(index)">
					<div class="faq-question">
						<span>{{ faq.question }}</span>
						<span class="faq-toggle">{{ expandedFaq === index ? '−' : '+' }}</span>
					</div>
					<transition name="slide">
						<div v-if="expandedFaq === index" class="faq-answer">
							<p>{{ faq.answer }}</p>
						</div>
					</transition>
				</div>
			</div>
		</div>

		<!-- 在线聊天 -->
		<div class="chat-section">
			<div class="chat-header">
				<h3 data-lang="t_230"></h3>
				<div class="status-indicator">
					<span class="status-dot"></span>
					<span data-lang="t_231"></span>
				</div>
			</div>

			<div class="chat-messages" ref="chatMessages">
				<div v-for="(msg, index) in chatMessages" :key="index" :class="['message', msg.type]">
					<div class="message-content">{{ msg.content }}</div>
					<div class="message-time">{{ msg.time }}</div>
				</div>
			</div>

			<div class="chat-input">
				<input v-model="newMessage" @keyup.enter="sendMessage" 
					:disabled="chatLoading" />
				<button @click="sendMessage" :disabled="chatLoading || !newMessage.trim()">
					<span v-if="chatLoading" class="loading-spinner"></span>
					<span v-else data-lang="t_232"></span>
				</button>
			</div>
		</div>

		<!-- 返回按钮 -->
		<button class="back-button" @click="handleBack" data-lang="t_217">
			
		</button>
	</div>
</template>

<script>
	export default {
		name: 'CustomerService',
		data() {
			return {
				expandedFaq: null,
				newMessage: '',
				chatLoading: false,
				chatMessages: [{
					type: 'bot',
					content: Lang[lg].t_233,
					time: '11:10'
				}],
				faqs: [{
						question: Lang[lg].t_234,
						answer: Lang[lg].t_235
					},
					{
						question: Lang[lg].t_236,
						answer: Lang[lg].t_237
					},
					{
						question: Lang[lg].t_238,
						answer: Lang[lg].t_239
					}
				]
			}
		},
		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			handleBack() {
				this.$emit('data-received', {
					message: 'profile',
				});
			},

			handleContact(type) {
				const actions = {
					email: () => window.open('mailto:agegfgm@gmail.com'),
					telegram: () => window.open('https://t.me/alphasocialcha'),
					twitter: () => window.open('https://x.com/alphasocialcha')
				};
				actions[type]?.();
			},

			toggleFaq(index) {
				this.expandedFaq = this.expandedFaq === index ? null : index;
			},

			async sendMessage() {
				if (!this.newMessage.trim()) return;

				const userMessage = this.newMessage;
				this.chatMessages.push({
					type: 'user',
					content: userMessage,
					time: new Date().getHours() + ':' + new Date().getMinutes()
				});

				this.newMessage = '';
				this.chatLoading = true;

				// 模拟客服回复
				setTimeout(() => {
					const responses = [
						Lang[lg].t_240,
						Lang[lg].t_241,
						Lang[lg].t_242,
						Lang[lg].t_243
					];

					const randomResponse = responses[Math.floor(Math.random() * responses.length)];

					this.chatMessages.push({
						type: 'bot',
						content: randomResponse,
						time: new Date().getHours() + ':' + new Date().getMinutes()
					});

					this.chatLoading = false;
					this.$nextTick(() => {
						this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
					});
				}, 1500);
			}
		},
		mounted() {
			this.setLanguage();
			this.$nextTick(() => {
				if (this.$refs.chatMessages) {
					this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
				}
			});
		}
	}
</script>

<style scoped>
	.customer-service-container {
		background-color: #000000;
		color: #e0e0e0;
		min-height: 100vh;
		padding: 20px;
		font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
	}

	.service-header {
		text-align: center;
		margin-bottom: 40px;
		padding-bottom: 20px;
		border-bottom: 1px solid #333;
	}

	.service-header h2 {
		color: #4dabf7;
		font-size: 2rem;
		margin-bottom: 8px;
	}

	.service-icon {
		margin-right: 10px;
	}

	.service-subtitle {
		color: #adb5bd;
		font-size: 0.9rem;
	}

	.contact-cards {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 20px;
		margin-bottom: 40px;
	}

	.contact-card {
		background: rgba(30, 30, 30, 0.9);
		border: 1px solid #333;
		border-radius: 12px;
		padding: 24px;
		cursor: pointer;
		transition: all 0.3s ease;
		position: relative;
	}

	.contact-card:hover {
		background: rgba(50, 50, 50, 0.9);
		border-color: #4dabf7;
		transform: translateY(-2px);
	}

	.card-icon {
		font-size: 2rem;
		margin-bottom: 12px;
	}

	.contact-card h3 {
		color: #74c0fc;
		margin-bottom: 8px;
	}

	.contact-card p {
		color: #adb5bd;
		margin-bottom: 0;
	}

	.card-arrow {
		position: absolute;
		right: 20px;
		top: 50%;
		transform: translateY(-50%);
		color: #4dabf7;
		font-size: 1.2rem;
	}

	.faq-section {
		margin-bottom: 40px;
	}

	.faq-section h3 {
		color: #74c0fc;
		margin-bottom: 20px;
		font-size: 1.3rem;
	}

	.faq-item {
		background: rgba(30, 30, 30, 0.9);
		border: 1px solid #333;
		border-radius: 8px;
		margin-bottom: 12px;
		overflow: hidden;
		cursor: pointer;
	}

	.faq-question {
		padding: 16px 20px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-weight: 500;
	}

	.faq-toggle {
		color: #4dabf7;
		font-size: 1.2rem;
		font-weight: bold;
	}

	.faq-answer {
		padding: 0 20px 16px;
		color: #adb5bd;
		border-top: 1px solid #333;
	}

	.slide-enter-active,
	.slide-leave-active {
		transition: max-height 0.3s ease;
	}

	.slide-enter-from,
	.slide-leave-to {
		max-height: 0;
	}

	.slide-enter-to,
	.slide-leave-from {
		max-height: 200px;
	}

	.chat-section {
		background: rgba(30, 30, 30, 0.9);
		border: 1px solid #333;
		border-radius: 12px;
		margin-bottom: 40px;
		overflow: hidden;
	}

	.chat-header {
		padding: 16px 20px;
		background: rgba(0, 0, 0, 0.5);
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #333;
	}

	.status-indicator {
		display: flex;
		align-items: center;
		gap: 8px;
		color: #20c997;
	}

	.status-dot {
		width: 8px;
		height: 8px;
		background-color: #20c997;
		border-radius: 50%;
		animation: pulse 2s infinite;
	}

	@keyframes pulse {

		0%,
		100% {
			opacity: 1;
		}

		50% {
			opacity: 0.5;
		}
	}

	.chat-messages {
		height: 300px;
		overflow-y: auto;
		padding: 20px;
	}

	.message {
		margin-bottom: 16px;
		max-width: 80%;
	}

	.message.user {
		margin-left: auto;
	}

	.message.bot {
		margin-right: auto;
	}

	.message-content {
		padding: 12px 16px;
		border-radius: 18px;
		word-break: break-word;
	}

	.message.user .message-content {
		background: #4dabf7;
		color: white;
		border-bottom-right-radius: 4px;
	}

	.message.bot .message-content {
		background: rgba(255, 255, 255, 0.1);
		border-bottom-left-radius: 4px;
	}

	.message-time {
		font-size: 0.75rem;
		color: #adb5bd;
		margin-top: 4px;
		text-align: right;
	}

	.message.user .message-time {
		text-align: right;
	}

	.message.bot .message-time {
		text-align: left;
	}

	.chat-input {
		padding: 16px;
		border-top: 1px solid #333;
		display: flex;
		gap: 12px;
	}

	.chat-input input {
		flex: 1;
		padding: 12px 16px;
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid #333;
		border-radius: 24px;
		color: white;
		font-size: 1rem;
	}

	.chat-input input:focus {
		outline: none;
		border-color: #4dabf7;
	}

	.chat-input button {
		padding: 12px 24px;
		background: #4dabf7;
		color: white;
		border: none;
		border-radius: 24px;
		font-weight: 600;
		cursor: pointer;
		min-width: 80px;
	}

	.chat-input button:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}

	.loading-spinner {
		display: inline-block;
		width: 16px;
		height: 16px;
		border: 2px solid rgba(255, 255, 255, 0.3);
		border-radius: 50%;
		border-top-color: white;
		animation: spin 1s linear infinite;
	}

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}

	.back-button {
		display: block;
		width: 100%;
		padding: 14px;
		background: rgba(255, 255, 255, 0.05);
		border: 1px solid #333;
		border-radius: 8px;
		color: #adb5bd;
		font-size: 1rem;
		cursor: pointer;
		transition: all 0.3s ease;
	}

	.back-button:hover {
		background: rgba(255, 255, 255, 0.1);
		border-color: #4dabf7;
		color: #4dabf7;
	}

	/* 滚动条样式 */
	.chat-messages::-webkit-scrollbar {
		width: 6px;
	}

	.chat-messages::-webkit-scrollbar-track {
		background: rgba(255, 255, 255, 0.05);
	}

	.chat-messages::-webkit-scrollbar-thumb {
		background: rgba(255, 255, 255, 0.2);
		border-radius: 3px;
	}

	.chat-messages::-webkit-scrollbar-thumb:hover {
		background: rgba(255, 255, 255, 0.3);
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.contact-cards {
			grid-template-columns: 1fr;
		}

		.chat-messages {
			height: 250px;
		}

		.message {
			max-width: 90%;
		}
	}
</style>